<template lang="html">
  <div class="mask-container">
    <div class="upload-container">
      <div @click="close" class="close"></div>
      <div v-if="showPic===false" v-text="$t('m.localUpload')" @click="uploadFile" class="uploadBtn"></div>
      <input type="file" id="file" @change="fileChange" accept="image/*">
      <div v-if="showPic" class="pic-container">
        <img :src="picList[index].pic_url">
        <div class="peopleName">
          <div class="character-container">
            <span v-text="$t('m.similarCharacters')"></span>
            <div>
              <p @click="index=key;navigateToSearchList(item.name)" v-for="(item,key) in picList">{{item.name}}</p>
            </div>
          </div>
          <div @click="uploadFile" :class="language==='zh-CN' ? 'btn' : 'btn on'" v-text="$t('m.reIdentification')"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import bus from '../bus'

export default {
  data() {
    return {
      language: 'zh-CN',
      showPic: false,
      picList: [],
      index: 0
    }
  },
  watch: {
    index(to) {
      var that = this;
      bus.$emit('search',{
        search: that.picList[to].name
      })
    }
  },
  methods: {
    close() {
      bus.$emit('closePicUpload')
    },
    navigateToSearchList(name) { // 跳转搜索列表
      bus.$emit('closePicUpload')
      bus.showAll = true;
      this.$router.push({
          name: 'searchList',
          params: {
              keyWord: encodeURIComponent(name)
          }
      })
    },
    uploadFile() { // 文件上传点击事件
      $('#file').click()
    },
    fileChange() { // input框change事件触发开始上传
      var that = this;
      var file = document.getElementById("file").files[0];
      console.log(file)
      if(file!=null&&file!=undefined&&file!=''){
        require('../utils.js').uploadWithToken({
          url: require('../config.json').urlBase + require('../config.json').url.pic.imgrec,
          data: {
            imageFile: file
          },
          success: function(res) {
            if(res.code=='10000'){
              if(res.result.length>0){
                that.index = 0;
                var picList = [];
                res.result.forEach(function(el){
                  if(el.score >= 0.80){
                    picList.push(el)
                  }
                })
                if(picList.length>0){
                  that.picList = picList;
                  that.showPic = true;
                  bus.$emit('search',{
                    search: res.result[0].name
                  })
                }else{
                  that.showPic = false;
                  that.picList = [];
                  bus.$emit('search',{
                    search: ''
                  })
                  if(that.language==='zh-CN'){
                    that.$message({
                      type: 'warning',
                      message: '未识别到人像'
                    })
                  }else{
                    that.$message({
                      type: 'warning',
                      message: 'No portrait recognized'
                    })
                  }
                }
              }else{
                that.showPic = false;
                that.picList = [];
                bus.$emit('search',{
                  search: ''
                })
                if(that.language==='zh-CN'){
                  that.$message({
                    type: 'warning',
                    message: '未识别到人像'
                  })
                }else{
                  that.$message({
                    type: 'warning',
                    message: 'No portrait recognized'
                  })
                }
              }
            }
          },
          error: function() {
            if(that.language==='zh-CN'){
              that.$message({
                  type: 'error',
                  message: '网络错误'
              })
            }else{
              that.$message({
                  type: 'error',
                  message: 'Network Error'
              })
            }
          }
        })
      }else{
        if(that.language==='zh-CN'){
          that.$message({
            type: 'warning',
            message: '未识别到人像'
          })
        }else{
          that.$message({
            type: 'warning',
            message: 'No portrait recognized'
          })
        }
      }
    }
  },
  created() {
    this.language = this.$i18n.locale;
  }
}
</script>

<style scoped>
  .mask-container {
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 99;
    width: 100%;
    height: 100%;
    background: rgba(16,22,62,0.2);
  }

  .upload-container {
    position: fixed;
    bottom: 0px;
    left: 50%;
    margin-left: -9.4rem;
    width: 18.8rem;
    height: 5.12rem;
    border-radius: 6px 6px 0 0;
    background: #FFF;
    border: 0.04rem solid #e0e7ff;
    box-sizing: border-box;
  }

  .upload-container .close {
    position: absolute;
    top: 0.22rem;
    right: 0.17rem;
    width: 0.3rem;
    height: 0.3rem;
    background: url('../assets/close.png') no-repeat;
    background-position: center;
    background-size: 100%;
    cursor: pointer;
  }

  .upload-container .close:hover {
    position: absolute;
    top: 0.22rem;
    right: 0.17rem;
    width: 0.3rem;
    height: 0.3rem;
    background: url('../assets/closeOn.png') no-repeat;
    background-position: center;
    background-size: 100%;
  }

  .upload-container .uploadBtn {
    width: 3rem;
    height: 0.88rem;
    line-height: 0.88rem;
    text-align: center;
    font-size: 0.36rem;
    color: #FFF;
    border-radius: 40px;
    border: 0.04rem solid #cfddfd;
    box-sizing: border-box;
    background: linear-gradient(to right, #5e8df7 , #1e69fe);
    margin: 2.1rem auto 0;
    cursor: pointer;
  }

  .upload-container .uploadBtn:hover {
    background: #1e69fe;
  }

  .upload-container .pic-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0.94rem 0 0 4.02rem;
  }

  .upload-container .pic-container img {
    width: 2.8rem;
    height: 3.2rem;
    border-radius: 6px;
    box-sizing: border-box;
    overflow: hidden;
  }

  .upload-container .pic-container .peopleName {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 10rem;
    height: 3.2rem;
    margin-left: 0.58rem;
  }

  .upload-container .pic-container .peopleName .character-container {
    display: flex;
    flex-direction: row;
    font-size: 0.36rem;
    color: #848a9d;
    user-select: none;
  }

  .upload-container .pic-container .peopleName .character-container > div {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .upload-container .pic-container .peopleName .character-container span {
    margin-right: 0.3rem;
  }

  .upload-container .pic-container .peopleName .character-container p {
    color: #1e69fe;
    margin-right: 0.44rem;
    margin-bottom: 0.22rem;
    cursor: pointer;
  }

  .upload-container .pic-container .peopleName .btn {
    width: 1.8rem;
    height: 0.6rem;
    line-height: 0.6rem;
    text-align: center;
    font-size: 0.28rem;
    color: #1e69fe;
    border: 0.02rem solid #5e8df7;
    border-radius: 40px;
    box-sizing: border-box;
    margin-left: 5.46rem;
    user-select: none;
    cursor: pointer;
  }

  .upload-container .pic-container .peopleName .btn.on {
    width: 2.8rem;
  }

  #file {
    position: absolute;
    bottom: -999999px;
  }
</style>
